export default __webpack_public_path__ + "static/KPMG-4b535a804111526b40191664cc41b08b.png";